export default "<ion-card>\r\n  <ion-card-content>\r\n    <h1>{{this.title}}</h1>\r\n    <p>{{this.message}}</p>\r\n  </ion-card-content>\r\n</ion-card>";